import { Component } from 'react'
import { StwReportQueryResult, DetailCell, StwOperation, StwOperationAction } from 'core/api'
import { AdvancedTableSortDirection } from 'core/components/AdvancedTable'
import Reports from 'core/api/Reports'
import { KeyValueGrid, StylewherePage, DefaultHeader, NotFound, Section, TableListReport } from '../../../components'
import Operations from '../../../api/Operations'
import { __, T } from '../../../shared/i18n'
import { SkeletonAttributeReport } from '../../../constants'
import { ExtendRouteComponentProps } from '../../../types'
import { getFragmentObject, getMultipleTitle, getBackURL, getHeaderOperationActions } from '../../../shared/utils'

interface State {
  reportInstance: StwReportQueryResult | undefined
  configuration: DetailCell[]
  loader: boolean
  operationInstanceId: string | undefined
  actions: StwOperationAction[]
}

export default class SimpleItemList extends Component<ExtendRouteComponentProps, State> {
  constructor(props) {
    super(props)
    this.state = {
      reportInstance: undefined,
      configuration: [],
      loader: true,
      operationInstanceId: undefined,
      actions: [],
    }
  }

  getDetailPath = () => {
    const { match } = this.props
    if (match.params.operationId && match.params.operationInstanceId)
      return `/operationlogs/SIMPLE_ITEM_LIST/${match.params.operationId}/${match.params.operationInstanceId}/item`
    return `/reports/item`
  }

  componentDidMount = async () => {
    const { match } = this.props
    if (match && match.params && match.params.operationInstanceId) {
      const params = { operationId: match.params.operationId }
      const reportId = await Operations.getReportId(match.params.operationId)
      const instance: any = await Reports.reportInstance(reportId, match.params.operationInstanceId, params)
      if (instance && instance.id) {
        const operation: StwOperation = await Operations.get<StwOperation>(match.params.operationId)
        const configuration = await Reports.getConfiguration(reportId, params)
        this.setState({
          operationInstanceId: match.params.operationInstanceId,
          reportInstance: instance,
          configuration: configuration,
          loader: false,
          actions: operation && operation.actions && operation.actions !== null ? operation.actions : [],
        })
      } else {
        this.setState({
          loader: false,
        })
      }
    } else {
      this.setState({
        loader: false,
      })
    }
  }

  render() {
    const { breadcrumbs, queryString, match } = this.props
    const { reportInstance, configuration, loader, operationInstanceId, actions } = this.state
    const fragment = getFragmentObject(reportInstance, 'id')
    return (
      <StylewherePage {...this.props} noOverflow fragment={fragment}>
        <DefaultHeader
          backPath={getBackURL(queryString, breadcrumbs)}
          multipleTitle={getMultipleTitle(reportInstance)}
          title={__(T.misc.not_found)}
          skeleton={{ active: loader, options: { multiple: true } }}
          actions={
            reportInstance
              ? getHeaderOperationActions(
                  'tracking',
                  'simpleItemList',
                  actions,
                  match.params.operationId,
                  match.params.operationInstanceId
                )
              : []
          }
        />
        <Section customClass={`stw-section-page paged-header ${reportInstance || loader ? 'scroll transparent' : ''}`}>
          {reportInstance || loader ? (
            <>
              <Section>
                <KeyValueGrid
                  fields={loader ? SkeletonAttributeReport : configuration}
                  data={reportInstance}
                  skeleton={loader}
                />
              </Section>
              {operationInstanceId && (
                <TableListReport
                  {...this.props}
                  reportId="item"
                  actions={[]}
                  fixedTableHeight
                  disabledReportExport
                  headerType="boxed"
                  title={__(T.titles.item)}
                  customColumnPrefix="simpleItemListDetailEntries"
                  reportActions={{ active: true, onlyedit: false }}
                  reportParams={{ simpleItemListId: operationInstanceId }}
                  sortValues={{ creationDate: AdvancedTableSortDirection.desc }}
                  disableLocation
                  pathDetail={this.getDetailPath()}
                />
              )}
            </>
          ) : (
            <NotFound fullheight title={__(T.misc.noRecordFoundTitle)} />
          )}
        </Section>
      </StylewherePage>
    )
  }
}
